<template>
  <div :class="$setClasses">
    <card-flex v-if="cardContent"
               no-box-shadow
               :mobile-wrapper-column="true"
               class="step-comparator-wrapper__header__card-flex"
               :icon="cardIcon"
               icon-green
               :content="cardContent">
    </card-flex>
    <div v-if="content"
         v-html="content"></div>
    <card-flex v-if="memoCardContent"
               :class="[$vClass('memo'),
                'step-comparator-wrapper__header__card-flex', 'u-margin-top-default']"
               :content="memoCardContent"
               :icon="stepConfig.memoCard.icon"
               icon-green
               :mobile-wrapper-column="true"
               no-box-shadow/>
    <el-card v-if="getTextVersion('signature.notice')"
             :class="$vClass('signing')">
      <p :class="$vClass('card__notice')"
         v-html="getTextVersion('signature.notice')"></p>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useComparatorStore, useConfigStore } from '@/stores';
import CardFlex from '@/utils/components/CardFlex.vue';
import { useMoveManagerEmits, useMoveManager, useMoveManagerProps } from '@/composables/useMoveManager';

export default {
  name: 'StepSignature',
  nameClassStyle: 'signature',
  emits: useMoveManagerEmits,
  props: useMoveManagerProps,
  setup( props, { emit } ) {
    return useMoveManager(props, { emit });
  },
  components: {
    CardFlex,
  },
  computed: {
    ...mapState(useComparatorStore, ['isSigningModalDisplayed']),
    ...mapState(useConfigStore, ['comparatorConfig', 'loading']),
    stepConfig() {
      return this.comparatorConfig.signature;
    },
    cardIcon() {
      return this.stepConfig?.card?.icon;
    },
    memoCardContent() {
      return this.stepConfig
        && this.getTextVersion(this.stepConfig?.memoCard?.content,
          this.getTextParams);
    },
    content() {
      return this.stepConfig && this.getTextVersion(this.stepConfig.content, this.getTextParams);
    },
    cardContent() {
      if (this.stepConfig?.card) {
        return this.$tIsAvailable(this.stepConfig.card.content)
          ? this.getTextVersion(this.stepConfig.card.content,
            this.getTextParams)
          : this.stepConfig.card.content;
      }
      return '';
    },
  },
  created() {
    if (this.stepConfig?.options?.autoSigningModal) {
      this.displaySigningModal(this.offer);
    }
  },
  methods: {
    ...mapActions(useConfigStore, { setLoadingAction: 'setLoading' }),
    ...mapActions(useComparatorStore, ['displaySigningModal']),
    nextStep() {
      this.displaySigningModal(this.offer);
    },
    setLoading(value) {
      this.setLoadingAction(value);
    },
  },
};
</script>

<style scoped lang="scss">
.signature {

  &__memo {
    background: transparent !important;

    :deep(svg) {
      color: var(--nxt-color-secondary);
    }
  }
}
</style>
